/**
 * Prevent UI actions when active
 */
function UILock() {
	'use strict';
	
	this.enabled = true;

	this.$body = $('body');
	this.$lock = $('<div class="ui-lock loading"/>');
	this.isLocked = false;
}

UILock.prototype = {

	/**
	 * Create UI lock
	 */
	activate: function () {
		'use strict';
		
		if (!this.enabled || this.isLocked) {
			return;
		}

		this.$body.prepend(this.$lock);
		this.isLocked = true;
	},

	/**
	 * RemoveUI lock
	 */
	deactivate: function () {
		'use strict';
		
		if (!this.enabled) {
			return;
		}
		
		this.$lock.detach();
		this.isLocked = false;
	},

	/**
	 * @return {Boolean}
	 */
	isLocked: function () {
		'use strict';

		return this.isLocked;
	},
	
	disable: function() {
		"use strict";
		
		this.enabled = false;
	},
	
	enable: function() {
		"use strict";
		
		this.enabled = true;
	}
};

export default UILock;